import { Element, useNode } from "@craftjs/core";

import BlockFloatingOptions from "@/content-hub/editor/floating-options/block-floating-options";
import { ColorLabels } from "@/content-hub/theme/constants";
import { Button } from "@/content-hub/theme/primitives/button/button";
import RichText from "@/content-hub/theme/primitives/rich-text";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/content-hub/theme/shared/block-wrapper";

import { StyledButtonContainer } from "../../sections/image-and-text-with-button-two-columns/text-with-button";
import VideoWithParagraphSettings from "./video-with-paragraph-settings";
import {
  LeftColumn,
  PaddingWrapper,
  VideoAndParagraphList,
} from "./video-with-paragraph-styles";

type VideoWithParagraphProps = {
  showCTA?: boolean;
  children: React.ReactNode;
};
export default function VideoWithParagraph(props: VideoWithParagraphProps) {
  const {
    id,
    connectors: { connect },
  } = useNode();

  return (
    <BlockBackgroundColorWrapper ref={connect} id={id} data-section-id={id}>
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <VideoAndParagraphList>
            <LeftColumn>
              <Element
                id="paragraph-item-sub-title"
                is={RichText}
                text={`<h3>Create engaging event experiences</h3>`}
              />
              <Element
                id="paragraph-item-description"
                is={RichText}
                text={`<p>Run personalized AI-powered events that reflect your brand, build community, and create a lasting impression with your audience from start to finish.</p>`}
              />
              {props.showCTA && (
                <StyledButtonContainer>
                  <Element
                    id="paragraph-item-cta"
                    is={Button}
                    text={"Take a tour"}
                    action={{
                      kind: "ExternalLink",
                      href: "https://ringcentral.navattic.com/3j104qi",
                    }}
                    colorSet={{
                      background: ColorLabels["BRAND-PRIMARY"],
                      text: ColorLabels["BRAND-SECONDARY-DARK"],
                      border: ColorLabels["BRAND-PRIMARY"],
                    }}
                  />
                </StyledButtonContainer>
              )}
            </LeftColumn>
            {props.children}
          </VideoAndParagraphList>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

VideoWithParagraph.craft = {
  isCanvas: true,
  custom: {
    displayName: "Video with title and text",
    settingsTitle: "selection-menu.selection.blocks.video-paragraph",
  },
  related: {
    leftOutlineOptions: BlockFloatingOptions,
    settings: VideoWithParagraphSettings,
  },
};
